<template>
	<nav id="sidebar" class="navbar-fixed-left active">
		<div class="sidebar-header">
			<img class="img-responsive dynvibeLogo" src="@/assets/img/logo.png" alt="Dynvibe" />
			<img class="img-responsive dynvibeLogoLive" src="@/assets/img/logo_live.png" alt="Dynvibe" />
		</div>
		<div style="align-items: center; height: calc(100vh - 100px); overflow: auto">
			<ul class="list-unstyled components">
				<li>
					<router-link :to="{ path: '/profiles' }">
						<i class="icon-user"></i>
						Profiles
					</router-link>
				</li>
				<li>
					<router-link to="/posts">
						<i class="icon-bookmark"></i>
						Posts
					</router-link>
				</li>
				<li>
					<router-link to="/rules">
						<i class="fas fa-ruler"></i>
						Rules
					</router-link>
				</li>
				<li>
					<router-link to="/panels">
						<i class="fas fa-address-book"></i>
						Panels
					</router-link>
				</li>
				<li>
					<router-link to="/categories">
						<i class="icon-brands"></i>
						Categories
					</router-link>
				</li>
				<li>
					<router-link to="/segments">
						<i class="fas fa-tags"></i>
						Segments
					</router-link>
				</li>
				<li>
					<router-link to="/newin">
						<i class="fas fa-exclamation-circle"></i>
						New In
					</router-link>
				</li>
				<li>
					<router-link to="/trend-validation">
						<i class="fas fa-check-circle"></i>
						Trend Validation
					</router-link>
				</li>
				<li>
					<router-link to="/explore">
						<i class="fas fa-newspaper"></i>
						Explore
					</router-link>
				</li>
				<li>
					<router-link to="/trend-deactivation">
						<i class="fas fa-times-circle"></i>
						Trend Deactivation
					</router-link>
				</li>
				<li>
					<router-link to="/animated">
						<i class="fas fa-chart-line"></i>
						Animated chart
					</router-link>
				</li>
				<!--
				<li>
					<router-link to="/exit">
						<i class="fas fa-door-open"></i>
						Exit Admin
					</router-link>
				</li>
				-->
			</ul>
		</div>
	</nav>
</template>

<script>
export default {};
</script>

<style></style>
